/**
 * A MUI card that collapses/expands the card content by toggling the header
 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMore from '@material-ui/icons/ExpandMore';

const propTypes = {
  // This could include any current or future-supported MUI card header props
  headerProps: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.shape({
    summary: PropTypes.string.isRequired,
    summaryContent: PropTypes.string.isRequired,
    summaryExpanded: PropTypes.string.isRequired,
    detail: PropTypes.string.isRequired,
    fullWidth: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {
  headerProps: null,
  children: null,
  className: null,
};

export function UnstyledCollapsibleCard({ headerProps, children, className, classes }) {
  return (
    <Card className={className}>
      <ExpansionPanel defaultExpanded>
        <ExpansionPanelSummary
          classes={{
            expanded: classes.summaryExpanded,
            content: classes.summaryContent,
            root: classes.summaryBorder,
            expandIcon: classes.expandIcon,
          }}
          className={classes.summary}
          expandIcon={<ExpandMore />}
        >
          <CardHeader
            {...headerProps}
            className={classnames(classes.fullWidth, headerProps.className)}
          />
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.detail}>
          <CardContent className={classes.fullWidth}>{children}</CardContent>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </Card>
  );
}

UnstyledCollapsibleCard.propTypes = propTypes;
UnstyledCollapsibleCard.defaultProps = defaultProps;

const styles = (theme) => ({
  summary: {
    padding: 0,
    display: 'flex',
  },
  summaryBorder: {
    borderBottom: '1px solid #D8D8D8',
  },
  // Need empty declaration to get proper rule specificity for expanded summary state
  summaryExpanded: {},
  summaryContent: {
    margin: 0,
    '&$summaryExpanded': {
      margin: 0,
    },
  },
  expandIcon: {
    marginRight: theme.spacing(1),
  },
  detail: {
    padding: 0,
    display: 'flex',
  },
  fullWidth: {
    width: '100%',
    borderBottom: 'unset',
  },
});

export default withStyles(styles)(UnstyledCollapsibleCard);
